<script setup lang="ts">
import IconDocument from '~/components/icons/legal-content/IconDocument.vue'

defineOptions({
	name: 'IntroductionSection',
})

const { t: $t } = useI18n()
</script>

<template>
	<section class="space-y-7">
		<div class="flex items-center gap-3.5">
			<IconDocument class="text-[#ED8B00] size-7" />
			<h2 class="text-xl sm:text-2xl font-medium text-gray-900 tracking-tight">
				{{ $t('General Overview') }}
			</h2>
		</div>
		<div class="space-y-5 text-base sm:text-[18px] text-[#364153] tracking-[-0.199px] leading-7">
			<p>
				{{
					$t(
						'The following Privacy Policy (“Policy”) outlines the collection, processing, and utilisation of Personal Data on the Luckywise website (“Platform”), made available by Gaveta Decimal, Lda., with registered office at Rotunda Eng. Edgar Cardoso No. 23, Sala F, having tax identification number 514677856, registered with the Commercial Registry Office of Vila Nova de Gaia under the same number, with a share capital of € 600,000 euros (“Gaveta Decimal”)',
					)
				}}.
			</p>
			<p>
				{{
					$t(
						'This Policy explains Gaveta Decimal’s data protection practices and informs users (“Users” or “Data Subjects”) about how to exercise their rights. This document is aligned with Regulation (EU) 2016/679 ("GDPR") and applicable legislation',
					)
				}}.
			</p>

			<p>
				{{
					$t(
						'Please read this Policy carefully before using the Platform, as it contains important information about Users’ rights and obligations, along with conditions, limitations, and exclusions that may apply',
					)
				}}.
			</p>

			<p>
				{{
					$t(
						'By using the Platform, clicking “I Accept” when prompted, or indicating acceptance in an adjoining box, Users confirm that they understand and agree to comply with this Policy in its entirety',
					)
				}}.
			</p>

			<p>
				{{ $t('If Users do not agree with this Policy, they should refrain from accessing or using the Platform') }}.
			</p>

			<p>
				{{
					$t(
						'Use of this website is only for individuals aged 18 or older, due to its content related to games of chance, even if only for entertainment purposes',
					)
				}}.
			</p>

			<p>
				{{
					$t(
						'This website is an independent project and has no official connection with the EuroMillions operator. All features are provided solely for informational and recreational purposes',
					)
				}}.
			</p>
		</div>
	</section>
</template>
